import type { GeneratedFile } from "./cached/GeneratedFile"
import type { MultiPagePdf } from "./cached/MultiPagePdf"
import type { RemoteFile } from "./cached/RemoteFile"
import type { SinglePageImage } from "./cached/SinglePageImage"
import type { SinglePagePdf } from "./cached/SinglePagePdf"
import type { ZipFile } from "./cached/ZipFile"

export type VirtualFile =
  | GeneratedFile
  | MultiPagePdf
  | RemoteFile
  | SinglePageImage
  | SinglePagePdf
  | ZipFile
